import { NgModule } from 'ng-metadata/core';
import {PrmSpinner} from './spinner.directive';

@NgModule({
    declarations: [
        PrmSpinner

    ],
    providers: [

    ],
    imports:[

    ]
})
export class SpinnerModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/spinner/spinner.module.ts